import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { About } from "../components/site/About";
import { Process } from "../components/site/Process";
import { SeasonCalendar } from "../components/site/SeasonCalendar";
import { Area } from "../components/site/Area";
import { Contact } from "../components/site/Contact";
import { FinalCta, Footer } from "../components/site/FinalCta";
import { scrollToId } from "../components/site/useLenis";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = "Gartenpflege in Herxheim und Umgebung | GRÜNWIRBEL";
    if (!hash) return undefined;
    const id = hash.slice(1);
    const jump = () => scrollToId(id, true);
    const timers = [setTimeout(jump, 100), setTimeout(jump, 700)];
    return () => timers.forEach(clearTimeout);
  }, [hash]);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <Process />
        <SeasonCalendar />
        <Area />
        <Contact />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}
